import React, { useState, useEffect } from "react";
import total from "../assets/images/dashboard/totalPro.png";
import male from "../assets/images/dashboard/malePro.png";
import female from "../assets/images/dashboard/femalePro.png";
import match from "../assets/images/dashboard/matchmakers.png";
import beauty from "../assets/images/dashboard/beauty.png";
import photo from "../assets/images/dashboard/photoGrp.png";
import event from "../assets/images/dashboard/eventMan.png";
import { Bar } from "react-chartjs-2";
import Dropdown from "react-bootstrap/Dropdown";
import { SlCalender } from "react-icons/sl";
import { ToastContainer, toast } from "react-toastify";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { axiosInstance_agent } from "../axiosInstance-agent";
import Preloader from "../Components/Preloader";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export function Dashboard() {
  const [agentUsersCount, setAgentUserCount] = useState([]);
  const [loading, setLoading] = useState(false);
  const [chartOne, setChartOne] = useState({});
  const [chartTwo, setChartTwo] = useState({});
  const [selectedLabel, setSelectedLabel] = useState("Last 7 days");
  const [show, setShow] = useState(false);
  async function FetchRegisterChartToday() {
    try {
      setLoading(true);
      const response = await axiosInstance_agent.get(
        "/admin/registration-count"
      );
      if (response.status === 200) {
        setChartOne(response.data);
      }
    } catch (error) {
      toast.error("Unable to fetch register data");
      console.log("Unable to fetch register data");
    } finally {
      setLoading(false);
    }
  }
  async function FetchRegisterChart({ day, date }) {
    try {
      setLoading(true);
      const response = await axiosInstance_agent.get(
        "/admin/registration-count",
        {
          params: { day, date },
        }
      );
      if (response.status === 200) {
        setChartTwo(response.data);
      }
    } catch (error) {
      toast.error("Unable to fetch register data");
      console.log("Unable to fetch register data");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    FetchRegisterChartToday();
    FetchRegisterChart({ day: 7 });
  }, []);

  const data1 = {
    labels: [
      "Male",
      "Female",
      "Matchmaker",
      "Beautician",
      "Photographer",
      "Event Manager",
    ],
    datasets: [
      {
        label: "Count",
        data: chartOne
          ? [
              chartOne.male_profile_count,
              chartOne.female_biodata_count,
              chartOne.matchmaker,
              chartOne.beautician,
              chartOne.photographer,
              chartOne.eventhallmanager,
            ]
          : [], // empty until API loads
        backgroundColor: [
          "rgba(255, 147, 0, 1)",
          "rgba(242, 68, 100, 1)",
          "rgba(63, 203, 105, 1)",
          "rgba(166, 149, 15, 1)",
          "rgba(136, 61, 4, 1)",
          "rgba(112, 74, 174, 1)",
        ],
        borderColor: [
          "rgba(255, 147, 0, 1)",
          "rgba(242, 68, 100, 1)",
          "rgba(63, 203, 105, 1)",
          "rgba(166, 149, 15, 1)",
          "rgba(136, 61, 4, 1)",
          "rgba(112, 74, 174, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options1 = {
    responsive: true,
    maintainAspectRatio: false, // Allows height adjustment
    plugins: {
      legend: {
        // position: "top",
        display: false,
      },
      title: {
        display: false,
        text: "Example Bar Chart",
      },
    },
    layout: {
      padding: {
        top: 10,
        bottom: 10, // Reduce padding to prevent extra space
      },
    },
  };
  const data2 = {
    labels: [
      "Male",
      "Female",
      "Matchmaker",
      "Beautician",
      "Photographer",
      "Event Manager",
    ],
    datasets: [
      {
        label: "Count",
        data: chartTwo
          ? [
              chartTwo.male_profile_count,
              chartTwo.female_biodata_count,
              chartTwo.matchmaker,
              chartTwo.beautician,
              chartTwo.photographer,
              chartTwo.eventhallmanager,
            ]
          : [], // empty until API loads
        backgroundColor: [
          "rgba(255, 147, 0, 1)",
          "rgba(242, 68, 100, 1)",
          "rgba(63, 203, 105, 1)",
          "rgba(166, 149, 15, 1)",
          "rgba(136, 61, 4, 1)",
          "rgba(112, 74, 174, 1)",
        ],
        borderColor: [
          "rgba(255, 147, 0, 1)",
          "rgba(242, 68, 100, 1)",
          "rgba(63, 203, 105, 1)",
          "rgba(166, 149, 15, 1)",
          "rgba(136, 61, 4, 1)",
          "rgba(112, 74, 174, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options2 = {
    responsive: true,
    maintainAspectRatio: false, // Allows height adjustment
    plugins: {
      legend: {
        // position: "top",
        display: false,
      },
      title: {
        display: false,
        text: "Example Bar Chart",
      },
    },
    layout: {
      padding: {
        top: 10,
        bottom: 10, // Reduce padding to prevent extra space
      },
    },
  };
  const fetchUserData = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance_agent.get(`/users-count`);
      const usersCount = response.data || [];
      setAgentUserCount(usersCount);
      console.log(usersCount);
    } catch (error) {
      console.error("Failed to fetch user agent count:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  return (
    <>
      <ToastContainer />
      {loading && <Preloader />}
      <div className="DashboardContainer">
        {/* first row */}
        <div className="row1">
          <div className="dashabord-card">
            <div>
              <img src={total}></img>
            </div>
            <div className="dashboard-content">
              <div className="content-title">Total Profiles</div>
              <div className="content-count">
                {(agentUsersCount?.matchmaker?.female_biodata_count || 0) +
                  (agentUsersCount?.matchmaker?.male_profile_count || 0)}
              </div>
            </div>
          </div>
          <div className="dashabord-card">
            <div>
              <img src={male}></img>
            </div>
            <div className="dashboard-content">
              <div className="content-title">Male Profiles</div>
              <div className="content-count">
                {agentUsersCount?.matchmaker?.male_profile_count || 0}
              </div>
            </div>
          </div>
          <div className="dashabord-card">
            <div>
              <img src={female}></img>
            </div>
            <div className="dashboard-content">
              <div className="content-title">Female Profiles</div>
              <div className="content-count">
                {agentUsersCount?.matchmaker?.female_biodata_count || 0}
              </div>
            </div>
          </div>
        </div>
        {/* second row */}
        <div className="row2">
          <div className="dashabord-card">
            <div>
              <img src={match}></img>
            </div>
            <div className="dashboard-content">
              <div className="content-title">Matchmakers</div>
              <div className="content-count">
                {agentUsersCount?.matchmaker?.matchmaker || 0}
              </div>
            </div>
          </div>
          <div className="dashabord-card">
            <div>
              <img src={beauty}></img>
            </div>
            <div className="dashboard-content">
              <div className="content-title">Beauticians</div>
              <div className="content-count">
                {agentUsersCount?.beautician || 0}
              </div>
            </div>
          </div>
          <div className="dashabord-card">
            <div>
              <img src={photo}></img>
            </div>
            <div className="dashboard-content">
              <div className="content-title">Photographers</div>
              <div className="content-count">
                {agentUsersCount?.photographer || 0}
              </div>
            </div>
          </div>
          <div className="dashabord-card">
            <div>
              <img src={event}></img>
            </div>
            <div className="dashboard-content">
              <div className="content-title">Event Manag.</div>
              <div className="content-count">
                {agentUsersCount?.eventhallmanager || 0}
              </div>
            </div>
          </div>
        </div>
        {/* third row */}
        <div className="row3">
          <div className="chart-container">
            <div className="chart-title">Registrations Today</div>
            <div
              className="chart-width"
              style={{ height: "300px", width: "100%" }}
            >
              <Bar data={data1} options={options1} />
            </div>
            <div className="chart-content">
              <div className="chart-row">
                <div>
                  <div>
                    <span
                      class="bi bi-circle-fill me-2"
                      style={{ color: "#FF9300", fontSize: "10px" }}
                    ></span>
                    <span className="chart-row-title">Male Profiles</span>
                  </div>
                  <div className="chart-row-count">
                    {chartOne?.male_profile_count ?? "--"}
                  </div>
                </div>
                <div>
                  <div>
                    <span
                      class="bi bi-circle-fill me-2"
                      style={{ color: "#F24464", fontSize: "10px" }}
                    ></span>
                    <span className="chart-row-title">Female Profiles</span>
                  </div>
                  <div className="chart-row-count">
                    {chartOne?.female_biodata_count ?? "--"}
                  </div>
                </div>
                <div>
                  <div>
                    <span
                      class="bi bi-circle-fill me-2"
                      style={{ color: "#3FCB69", fontSize: "10px" }}
                    ></span>
                    <span className="chart-row-title">Matchmakers</span>
                  </div>
                  <div className="chart-row-count">
                    {chartOne?.matchmaker ?? "--"}
                  </div>
                </div>
              </div>
              <div className="chart-row">
                <div>
                  <div>
                    <span
                      class="bi bi-circle-fill me-2"
                      style={{ color: "#A6950F", fontSize: "10px" }}
                    ></span>
                    <span className="chart-row-title">Beauticians</span>
                  </div>
                  <div className="chart-row-count">
                    {chartOne?.beautician ?? "--"}
                  </div>
                </div>
                <div>
                  <div>
                    <span
                      class="bi bi-circle-fill me-2"
                      style={{ color: "#883D04", fontSize: "10px" }}
                    ></span>
                    <span className="chart-row-title">Photographers</span>
                  </div>
                  <div className="chart-row-count">
                    {chartOne?.photographer ?? "--"}
                  </div>
                </div>
                <div>
                  <div>
                    <span
                      class="bi bi-circle-fill me-2"
                      style={{ color: "#704AAE", fontSize: "10px" }}
                    ></span>
                    <span className="chart-row-title">Event Manager</span>
                  </div>
                  <div className="chart-row-count">
                    {chartOne?.eventhallmanager ?? "--"}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="chart-container">
            <div className="LastdaysCont">
              <div className="chart-title">Filter</div>
              <div>
                <Dropdown show={show} onToggle={() => setShow(!show)}>
                  <Dropdown.Toggle
                    className="dropdown-chart-btn"
                    id="dropdown-basic"
                  >
                    {selectedLabel}
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="dropdown-menu">
                    <div
                      onClick={() => {
                        setShow(false); // close dropdown manually
                        setSelectedLabel("Last 7 days");
                        FetchRegisterChart({ day: 7 });
                      }}
                    >
                      Last 7 days
                    </div>
                    <div
                      onClick={() => {
                        setShow(false); // close dropdown  manually
                        setSelectedLabel("Last 15 days");
                        FetchRegisterChart({ day: 15 });
                      }}
                    >
                      Last 15 days
                    </div>
                    <div
                      onClick={() => {
                        setShow(false); // close dropdown  manually
                        setSelectedLabel("Last 30 days");
                        FetchRegisterChart({ day: 30 });
                      }}
                    >
                      Last 30 days
                    </div>
                    <div>
                      {/* <span>
            <SlCalender />
          </span> */}
                      Custom Date :
                    </div>
                    <div>
                      <input
                        type="date"
                        className="form-control"
                        onChange={(e) => {
                          setShow(false); // close manually
                          setSelectedLabel(e.target.value); // show selected date
                          FetchRegisterChart({ date: e.target.value });
                        }}
                      />
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
            <div
              className="chart-width"
              style={{ height: "300px", width: "100%" }}
            >
              <Bar data={data2} options={options2} />
            </div>
            <div className="chart-content">
              <div className="chart-row">
                <div>
                  <div>
                    <span
                      class="bi bi-circle-fill me-2"
                      style={{ color: "#FF9300", fontSize: "10px" }}
                    ></span>
                    <span className="chart-row-title">Male Profiles</span>
                  </div>
                  <div className="chart-row-count">
                    {chartTwo?.male_profile_count ?? "--"}
                  </div>
                </div>
                <div>
                  <div>
                    <span
                      class="bi bi-circle-fill me-2"
                      style={{ color: "#F24464", fontSize: "10px" }}
                    ></span>
                    <span className="chart-row-title">Female Profiles</span>
                  </div>
                  <div className="chart-row-count">
                    {chartTwo?.female_biodata_count ?? "--"}
                  </div>
                </div>
                <div>
                  <div>
                    <span
                      class="bi bi-circle-fill me-2"
                      style={{ color: "#3FCB69", fontSize: "10px" }}
                    ></span>
                    <span className="chart-row-title">Matchmakers</span>
                  </div>
                  <div className="chart-row-count">
                    {chartTwo?.matchmaker ?? "--"}
                  </div>
                </div>
              </div>
              <div className="chart-row">
                <div>
                  <div>
                    <span
                      class="bi bi-circle-fill me-2"
                      style={{ color: "#A6950F", fontSize: "10px" }}
                    ></span>
                    <span className="chart-row-title">Beauticians</span>
                  </div>
                  <div className="chart-row-count">
                    {chartTwo?.beautician ?? "--"}
                  </div>
                </div>
                <div>
                  <div>
                    <span
                      class="bi bi-circle-fill me-2"
                      style={{ color: "#883D04", fontSize: "10px" }}
                    ></span>
                    <span className="chart-row-title">Photographers</span>
                  </div>
                  <div className="chart-row-count">
                    {chartTwo?.photographer ?? "--"}
                  </div>
                </div>
                <div>
                  <div>
                    <span
                      class="bi bi-circle-fill me-2"
                      style={{ color: "#704AAE", fontSize: "10px" }}
                    ></span>
                    <span className="chart-row-title">Event Manager</span>
                  </div>
                  <div className="chart-row-count">
                    {chartTwo?.eventhallmanager ?? "--"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
